<template>
  <CompatibleWith
    v-if="productResponse?.compatibleProducts?.length"
    class="mt-6"
    :compatible-products="productResponse.compatibleProducts"
  />
</template>

<script setup lang="ts">
import CompatibleWith from '~/scopes/product-core/components/presentationals/CompatibleWith/CompatibleWith.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
</script>
